/* eslint-disable no-lone-blocks */
/* eslint-disable jsx-a11y/alt-text */
import { useEffect, useState } from "react";
import { RootState, useAppSelector } from "../redux/AppStore";
export default function ImageComponent() {
    const [dates, setDates] = useState<string[]>([]);
    const [bookingConfirmedimage, setBookingConfirmedimage] = useState('/img/svg/BookingConfirmed-gray.png');
    const [pickedUpimage, setPickedUpimage] = useState('/img/svg/PickedUp-gray.png');
    const [outforDeliveryimage, setOutforDeliveryimage] = useState('/img/svg/OutforDelivery-gray.png');
    const [deliveredimage, setDeliveredimage] = useState('/img/svg/Delivered-gray.png');
    const trackinginfo = useAppSelector((state: RootState) => state.tracking.trackingdata);

    useEffect(() => {
        setDates(Object.keys(trackinginfo));
    }, [trackinginfo]);

    useEffect(() => {
        setBookingConfirmedimage("/img/svg/BookingConfirmed-gray.png");
        setPickedUpimage("/img/svg/PickedUp-gray.png");
        setOutforDeliveryimage("/img/svg/OutforDelivery-gray.png");
        setDeliveredimage("/img/svg/Delivered-gray.png");
        if (dates != null) {
            for (let v of dates) {
                for (let d of trackinginfo[v]) {
                    if ((d.code_text === 'Booking Confirmed' || d.code_text === 'Collected' || d.code_text === 'Out For Delivery'
                        || d.code_text === 'Delivered' || d.code_text === 'collection Carded By Controller' || d.code_text === 'Collection Attempted')) {
                        setBookingConfirmedimage("/img/svg/BookingConfirmed-blue.png")
                    }
                    if ((d.code == 'IN_TRANSIT' || d.code == 'GENERAL_HUB_UNLOAD' || d.code == 'GENERAL_HUB_LOAD' || d.code == 'GENERAL_DRIVER_UNLOAD' || d.code == 'UNLOAD' || d.code_text == 'Delivery Carded' || d.code == "LOAD" || d.code_text == 'Carded-In Warehouse' ||
                        d.code_text === 'Collected' || d.code_text === 'Out For Delivery' || d.code_text === 'Delivery Return' || d.code_text === 'Partly Delivered' || d.code_text === 'Received in Warehouse by Controller' || d.code_text === 'Returned By Controller' ||
                        d.code_text === 'Delivered' || d.code_text === 'Delivery Attempted' || d.code_text === 'Delivery Carded By Controller' || d.code_text == 'In Transit' || d.code_text === 'Partly Collected' || d.code_text == "Returned In Warehouse" ||
                        d.code === 'DELIVERY_CARDED' || d.code == 'WAREHOUSE_SCAN' || d.code === 'AT_DELIVERY_LOCATION')){
                        if (d.code !== 'EXCEPTION' && d.code != 'COLLECTIONAWAITED' && d.code != 'DELAYED') {       
                            setPickedUpimage("/img/svg/PickedUp-blue.png");
                        }else{
                        setPickedUpimage("/img/svg/PickedUp-gray.png")
                        }
                }
                    if ((d.code === 'GENERAL_OPEN_LOAD' || d.code_text === 'Delivered' || d.code == "LOAD" || d.code == 'DELIVERYSUCCESS' || d.code == 'OUTFORDELIVERY' || d.code == 'DELIVERYSHORTAGE')
                    ) {
                        if ((d.code_text !== 'The receiver does not want the product and refused the delivery. / The package is being returned to' && d.code !== 'EXCEPTION' && d.code !== 'DELIVERY_CARDED' && d.code !== 'RETURNED' && d.code_text !== 'Returned In Warehouse' && d.code_text != 'Delivery Carded By Controller'
                            && d.code_text != 'Received in Warehouse by Controller' && d.code != 'WAREHOUSE_SCAN' && d.code != 'DELAYED' && d.code != 'IN_TRANSIT')) {
                                setOutforDeliveryimage("/img/svg/OutforDelivery-blue.png");
                        }else{
                            setOutforDeliveryimage("/img/svg/OutforDelivery-gray.png");
                        }
                    }
                    if ((d.code == 'DELIVERYSUCCESS' || d.code_text === 'Delivered')) {
                        setDeliveredimage("/img/svg/Delivered-blue.png")
                    }
                }
            }
        }
    }, [dates])
    return (
        <>
            <ul id="progressbar" className="act_list">
                <><li className="active-s">
                    <div className="list_controll">
                        <img src={bookingConfirmedimage} />
                        <strong>Booking Confirmed</strong>
                    </div>
                </li><li className="active-s">
                        <div className="list_controll">
                            <img src={pickedUpimage} />
                            <strong>Picked Up</strong>
                        </div>
                    </li><li className="active-s">
                        <div className="list_controll">
                            <img src={outforDeliveryimage} />
                            <strong>Out for Delivery</strong>
                        </div>
                    </li><li className="active-s">
                        <div className="list_controll">
                            <img src={deliveredimage} />
                            <strong>Delivered</strong>
                        </div>
                    </li></>
            </ul>
        </>
    )

}
